/**
 * The check mark used in the landing page's lists (part of the approved
 * design in pos-landing.html).
 *
 * @param {object} props
 * @param {number} [props.strokeWidth]
 * @returns {JSX.Element}
 */
function PosLandingTick({ strokeWidth = 2.4 }) {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="m20 6-11 11-5-5" />
    </svg>
  );
}

export default PosLandingTick;
